import { render, staticRenderFns } from "./AcercaDe.vue?vue&type=template&id=1b9a1e6a&"
import script from "./AcercaDe.js?vue&type=script&lang=js&"
export * from "./AcercaDe.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports